export default (function () {

  /**
   * fixed sidebar
   *
   */

   const fixedsidebar = document.querySelector('.js-fixedsidebar');

   if (fixedsidebar != undefined && fixedsidebar != null) {
  
   var windowWidth = document.body.clientWidth;
   var windowSm = 768;
   if (windowWidth >= windowSm) {
      const footer = document.querySelector("#footer");
    
      const options = {
        root: null, // 今回はビューポートをルート要素とする
        rootMargin: "0px", // ビューポートの中心を判定基準にする
        threshold: 0 // 閾値は0
      };
    
      const observer = new IntersectionObserver(doWhenIntersect, options);
      observer.observe(footer);
    
      function doWhenIntersect(entries) {
    
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            fixedsidebar.classList.add('is-over');
          }else{
            fixedsidebar.classList.remove('is-over');
          }
        });
      }
   } 

  }

})();
